import htmx from 'htmx.org';

htmx.config.allowNestedOobSwaps = true;
htmx.config.defaultSettleDelay = 0;
window.htmx = htmx;
